import { useEffect, useRef } from "react"

/**
 * Hook that returns the previous value of a ref.
 * @param {any} value - The current value of the ref.
 * @returns {any} The previous value of the ref.
 */
export const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
